export MDCComponent from './MDCComponent'

export default from './MDCComponent'



// WEBPACK FOOTER //
// ./src/MDCComponent/index.js